module.exports = {"id":"dp2_5l3q3","text":"Digital Behaviour","instructions":"Children and adults have different rights and responsibilities online.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.5","questionType":"PickOne","random":false,"options":[{"id":"dp2_5l3q3-a1","text":"True","score":3.7},{"id":"dp2_5l3q3-a2","text":"Not sure","score":1.3},{"id":"dp2_5l3q3-a3","text":"False","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.5/l3q3.json
// module id = 1074
// module chunks = 41